<template>
  <div class="view-point-green">
    <dl>
      <dt>
        <img
          class="mb10 review-icon"
          :src="`${userOfferImageUrlForSp}/reviews.png`"
          alt="reviews"
        >
        <span class="fs14 fwB">
          <a
            target="_blank"
            class="pb5 text-black"
          >
            <span
              class="fs14 fwB"
              data-test="company-name"
            >{{ companyName }}</span>
            社員からの評判・口コミをチェック！
          </a>
        </span>
      </dt>
      <dd>
        <template v-for="(realIntention, i) in realIntentions">
          <div
            :key="`real-intention-${i}`"
            class="three-line"
          >
            <p>
              <span><img
                :src="`${userOfferImageUrlForSp}/icn_circle.png`"
                alt="circle"
                class="circle-icon"
              ></span><span class="overflow">{{ realIntention.answer1 }}</span>
            </p>
          </div>
          <p
            :key="`real-intention-status-${i}`"
            class="realintention-right"
          >
            <span class="realintention-right">({{ realIntention.gender.name }}/{{ realIntention.career }})</span>
          </p>
        </template>
        <job-preview-button title="社員からの評判・口コミをすべて見る" />
      </dd>
    </dl>
  </div>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/offer/base" as *;
</style>

<script>
import jobPreviewCommon from '@/lib/jobPreviewCommon'
import JobPreviewButton from '@/components/atoms/JobPreviewButton'

export default {
  components: {
    JobPreviewButton
  },
  mixins: [jobPreviewCommon],
  props: {
    companyName: {
      type: String,
      required: true
    },
    realIntentions: {
      type: Array,
      default: () => []
    }
  }
}
</script>
